import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import { ConstantsPlugin,loadData } from './plugins/const'
import axios from '@/plugins/axios'

Vue.use(ElementUI)
Vue.use(ConstantsPlugin)

const beginer = async function(){
  try{
    const ssid = sessionStorage.getItem('ss_id')
    if(ssid === null){
      const res = await axios.get('/startSession')

      sessionStorage.setItem('ss_id', res.sessionId)
      sessionStorage.setItem('key', res.key)
    }
    loadData()
    new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }catch(err){
    alert('System Error')
  }
}

beginer()
